import React from 'react';
import PropTypes from 'prop-types';
import { NavBar } from 'cccisd-laravel-boilerplate';
import Modal from 'cccisd-modal';
import IconQuestion from 'cccisd-icons/question4';
import IconBook from 'cccisd-icons/book3';
import HelpCenter from 'cccisd-help-center';
import Tutorial from 'js/components/Tutorial';
import style from './style.css';

const Boilerplate = window.cccisd.boilerplate;

export default class Component extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        showMenu: PropTypes.bool,
        showSaveButton: PropTypes.bool,
        showHelpLink: PropTypes.bool,
        saveButtonUrl: PropTypes.string,
    };

    static defaultProps = {
        className: 'container',
        showMenu: true,
        showHelpLink: true,
        saveButtonUrl: 'member',
    };

    openHelpCenter = e => {
        e && e.preventDefault();
        this.modalHelp.open();
    };

    openTutorial = e => {
        e && e.preventDefault();
        this.modalTutorial.open();
    };

    render() {
        let showTheseProfileDataFields = {
            orgAdmin: ['positionTitle'],
            clubContact: ['positionTitle'],
        };

        return (
            <div>
                <Modal
                    trigger={null}
                    title="Need Help?"
                    ref={elem => {
                        this.modalHelp = elem;
                    }}
                    size="large"
                >
                    <HelpCenter helpCenter="default" />
                </Modal>
                <Modal
                    trigger={null}
                    title="Registration Tutorial"
                    size="large"
                    ref={elem => {
                        this.modalTutorial = elem;
                    }}
                >
                    <Tutorial />
                </Modal>
                <NavBar
                    className={this.props.className}
                    logo={<div className={style.logo} />}
                    showMenu={this.props.showMenu}
                    allowSwitchRoles
                    showTheseProfileDataFields={showTheseProfileDataFields}
                    hideSeparateRoleSwitcher
                >
                    {this.props.showHelpLink && (
                        <li>
                            <a href="#" onClick={this.openHelpCenter}>
                                <IconQuestion spaceRight />
                                Need Help
                            </a>
                        </li>
                    )}
                    <li>
                        <a href="#" onClick={this.openTutorial}>
                            <IconBook spaceRight />
                            <b>Registration Tutorial</b>
                        </a>
                    </li>
                    {this.props.showSaveButton && (
                        <div className="navbar-form navbar-right">
                            <a href={Boilerplate.url(this.props.saveButtonUrl)} className="btn btn-primary">
                                Save and exit
                            </a>
                        </div>
                    )}
                </NavBar>
            </div>
        );
    }
}
